import { render } from "./Default.vue?vue&type=template&id=75aa985b"
import script from "./Default.vue?vue&type=script&setup=true&lang=js"
export * from "./Default.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/layouts/Default.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75aa985b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75aa985b', __exports__)) {
    api.reload('75aa985b', __exports__)
  }
  
  module.hot.accept("./Default.vue?vue&type=template&id=75aa985b", () => {
    api.rerender('75aa985b', render)
  })

}


export default __exports__